/**
 * Feature Module.
 *
 * This gives more flexibility around the feature
 * section with background images and short and
 * long text. Accomodates the print like designs.
 *
 * @param data
 */

/**
 * Include the dependencies.
 */
var $ = require('jquery');


/**
 * Finds all the feature to update.
 *
 */
var updateAllFeature = function () {

    var $article_elem = $('body');

    updateFeature($article_elem);
};

/**
 * Updates the position of the feature overlay.
 *
 */
var updateFeature = function ($article_elem) {

    var $top_story = $article_elem.find('.feature .top-story');
    var $feature_overlay = $top_story.find('.feature-overlay');

    if ($feature_overlay.length > 0) {
        var padding = $feature_overlay.css('padding-top').replace(/[^-\d\.]/g, '') * 1;
        var difference = ($top_story.height() - $feature_overlay.height() - padding - padding) * 1;
        if ( difference > 40 ) {
            $top_story.css('padding-top', (difference + 40) * 1 );
        }

    }
};

/**
 * Methods to execute immediately.
 */
var init = function () {
    updateAllFeature();
};

/**
 * Export all of the methods.
 */
module.exports = {
    init: init,
    updateFeature: updateFeature
};
